@if (selectedIndex !== null) {
    <mat-tab-group
        class="sb-tab-body"
        [class.sb-tab-body-animation-complete]="isAnimationComplete"
        [preserveContent]="true"
        [disableRipple]="true"
        [disablePagination]="true"
        [style.--mat-tab-animation-duration]="animationDuration"
        [animationDuration]="animationDuration"
        [selectedIndex]="selectedIndex"
        (animationDone)="AnimationDone()">
        @for (tab of tabComponentQueryList; track TrackTab(tab, $index); let index = $index) {
            @if (kind === TabKind.Default || (kind === TabKind.Stepper && selectedIndex >= index)) {
                @if (tab.lazyLoad) {
                    <mat-tab>
                        <ng-template matTabContent>
                            <ng-container *ngTemplateOutlet="tab.tabContent"></ng-container>
                        </ng-template>
                    </mat-tab>
                } @else {
                    <mat-tab>
                        <ng-container *ngTemplateOutlet="tab.tabContent"></ng-container>
                    </mat-tab>
                }
            }
        }
    </mat-tab-group>
}
